module.exports = __webpack_public_path__ + "img/cron-check.1017a29c.svg";